{
	"title": "Verklaring aanmaken",
	"backLinkToMaterialDetailsTitle": "Terug naar materiaaldetails",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Terug naar {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Terug naar Verklaringen beheren",
	"steps": {
		"firstStep": {
			"title": "Stap 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Stap 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Stap 3",
			"label": "3"
		}
	}
}
